"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConflictError = exports.TokenInvalidError = exports.TokenExpiredError = void 0;
const ApiErrorBase_1 = require("./ApiErrorBase");
class TokenExpiredError extends ApiErrorBase_1.ApiErrorBase {
    constructor(code, message, canRetry) {
        super(code, message, canRetry);
    }
}
exports.TokenExpiredError = TokenExpiredError;
class TokenInvalidError extends ApiErrorBase_1.ApiErrorBase {
    constructor(code, message, canRetry) {
        super(code, message, canRetry);
    }
}
exports.TokenInvalidError = TokenInvalidError;
class ConflictError extends ApiErrorBase_1.ApiErrorBase {
    constructor(code, message, canRetry) {
        super(code, message, canRetry);
    }
}
exports.ConflictError = ConflictError;
//# sourceMappingURL=ApiErrors.js.map